import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_chauffeur-prive-29/artifacts/ebdff0165cb41c3c_Van%20D%27Iroise.jpg";

const PolitiqueConfidentialite = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#f8f7f2]">
      {/* Header */}
      <header className="bg-[#1a1d2e] py-5">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Van d'Iroise"
              className="h-[48px] w-auto object-contain"
            />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-[14px] text-white/70 hover:text-[#c9a84c] transition-colors duration-200"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            <ArrowLeft size={16} />
            Retour à l'accueil
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-[860px] mx-auto px-6 md:px-10 py-16 md:py-24">
        <h1
          className="text-[32px] md:text-[40px] font-normal text-[#1a1d2e] leading-[1.2] mb-4"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Politique de Confidentialité
        </h1>
        <div className="gold-line mb-10" />

        <p
          className="text-[15px] text-[#555] leading-[1.8] mb-10"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          Le site web VTC29 est détenu et exploité par VTC29, représenté par M. Vincent TIXIER, qui agit en tant que responsable du traitement de vos données personnelles. Nous avons mis en place la présente politique de confidentialité afin d'expliquer comment nous collectons, utilisons et protégeons vos données personnelles.
        </p>

        {/* Données personnelles collectées */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Données personnelles collectées
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8] mb-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Lorsque vous visitez le site, nous recueillons automatiquement certaines informations :
          </p>
          <div className="border-l-2 border-[#c9a84c] pl-6 mb-4">
            <ul className="space-y-2 text-[15px] text-[#555] leading-[1.7]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              <li>Type de navigateur</li>
              <li>Adresse IP</li>
              <li>Fuseau horaire</li>
              <li>Cookies installés sur votre appareil</li>
              <li>Pages consultées, interactions avec le site</li>
            </ul>
          </div>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            De plus, nous collectons les données que vous nous fournissez via les formulaires de contact ou de réservation : nom, prénom, adresse, téléphone, e-mail, informations de paiement, etc.
          </p>
        </section>

        {/* Pourquoi traitons-nous vos données */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Pourquoi traitons-nous vos données ?
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8] mb-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Nous traitons uniquement les données strictement nécessaires pour :
          </p>
          <div className="border-l-2 border-[#c9a84c] pl-6 mb-4">
            <ul className="space-y-2 text-[15px] text-[#555] leading-[1.7]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              <li>Assurer le bon fonctionnement du site</li>
              <li>Répondre à vos demandes ou messages</li>
              <li>Gérer les réservations et contrats de service</li>
              <li>Protéger nos intérêts légitimes (sécurité, prévention des abus)</li>
            </ul>
          </div>
          <p className="text-[15px] text-[#1a1d2e] leading-[1.8] italic" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Note : Ces données ne sont ni revendues ni utilisées à d'autres fins commerciales.
          </p>
        </section>

        {/* Vos droits */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Vos droits
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8] mb-4" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Si vous êtes résident de l'Union européenne, vous disposez des droits suivants :
          </p>
          <div className="border-l-2 border-[#c9a84c] pl-6 mb-4">
            <ul className="space-y-2 text-[15px] text-[#555] leading-[1.7]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
              <li>Droit d'accès, de rectification et d'effacement</li>
              <li>Droit à la limitation du traitement et d'opposition</li>
              <li>Droit à la portabilité des données</li>
              <li>Droit de retirer votre consentement à tout moment</li>
            </ul>
          </div>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Pour exercer ces droits, contactez-nous à :{" "}
            <a href="mailto:vtc29chauffeurprive@gmail.com" className="text-[#c9a84c] hover:underline">
              vtc29chauffeurprive@gmail.com
            </a>
          </p>
        </section>

        {/* Sécurité des données */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Sécurité des données
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Vos informations sont stockées sur des serveurs sécurisés. Des mesures techniques et organisationnelles sont mises en œuvre pour limiter tout accès non autorisé, perte ou divulgation. Cependant, aucune transmission via Internet n'est totalement sécurisée. L'utilisation du site reste donc à vos propres risques.
          </p>
        </section>

        {/* Liens externes */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Liens externes
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Notre site peut contenir des liens vers d'autres sites. Nous ne sommes pas responsables des pratiques de confidentialité de ces sites tiers. Nous vous invitons à consulter leur propre politique de confidentialité.
          </p>
        </section>

        {/* Divulgation légale */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Divulgation légale
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Nous pourrons divulguer vos données si la loi l'exige (ex. : procédure judiciaire, demande des autorités, prévention des fraudes ou atteinte à la sécurité).
          </p>
        </section>

        {/* Contact */}
        <section className="mb-10">
          <h2
            className="text-[20px] font-medium text-[#1a1d2e] mb-4"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Contact
          </h2>
          <p className="text-[15px] text-[#555] leading-[1.8]" style={{ fontFamily: "'DM Sans', sans-serif" }}>
            Pour toute question relative à cette politique de confidentialité ou à vos données personnelles :{" "}
            <a href="mailto:vtc29chauffeurprive@gmail.com" className="text-[#c9a84c] hover:underline">
              vtc29chauffeurprive@gmail.com
            </a>
          </p>
        </section>
      </main>

      {/* Footer mini */}
      <footer className="bg-[#12141f] py-8">
        <div className="max-w-[860px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p
            className="text-[12px] text-white/20"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            © {new Date().getFullYear()} Van d'Iroise — Chauffeur privé. Tous droits réservés.
          </p>
          <Link
            to="/"
            className="text-[12px] text-white/40 hover:text-[#c9a84c] transition-colors"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Retour à l'accueil
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default PolitiqueConfidentialite;
